import CustomCalendar from "../../components/utils/CustomCalendar"
import _moment from "../../libs/moment"

export default (context) => {
  const M = "admCalendar."
  return {
    config: {
      resource: "admActivity",
      customPathGet: "admActivity/month/0",
      pageSize: 40,
      list: false,
      remapRow: (form) => {
        return form
      },
      hiddenButtons: true,
      hiddenGrid: true
    },

    actions: {},

    filter: {
      fields: [
        {
          name: "type",
          type: "hidden",
          value: "cal"
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "main.grade",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: "",
          type: "select",
          label: "main.section",
          parent: "superSectionId",
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
          }
        }
      ],
      buttons: [
        {
          label: 'main.applyFilter',
          onClick: ctx => ctx.btnAction('filter')
        }
      ]
    },

    form: {
      remapOne: (r) => {
        r.data.categoryId = { value: r.data.categoryId, label: r.data.categoryName }
        r.data.owner = {value: r.data.owner, label: r.data.ownerName}
        return r
      },
      setValuesBeforePost: (v) => {
        if (v.superSections) {
          v.superSections = v.superSections.map(e => {
            e = {
              ID: e.value,
              name: e.label,
              selected: true,
            }
            return e
          })
        }
        if (v.sections) {
          v.sections = v.sections.map(e => {
            e = {
              ID: e.value,
              name: e.label,
              selected: true,
            }
            return e
          })
        }
        delete v.selectedField
        return v
      },
      fields: [
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: "main.title",
          rules: "required|max:150",
          opts: {
            style: 'float-label',
          }
        },
        {
          type: "daterange",
          isFormCrud: true,
          from: {
            col: 4,
            name: "startDate",
            value: "",
            type: "datetime",
            label: `${M}startDateTime`,
            rules: "required",
            opts: {
             timeIntervals: 15,
            },
            renderIf: () => true,
          },
          range: {
            col: 4,
            label: `${M}duration`,
            rules: () => (context.state.form?.startDate && context.state.form?.endDate) ? null : 'required',
            opts: {
              itemsF: () => [
                {value: 0, label: `${M}oneHour`},
                {value: 1, label: `${M}threeHours`},
                {value: 2, label: `${M}oneDay`},
                {value: 3, label: `main.anotherDateRange`}
              ]
            },
            onChange: (ctx) => {
              const baseDate = ctx.state.startDate ? _moment(ctx.state.startDate) : _moment()
              if (ctx.state.range === 0) ctx.setState({endDate: baseDate.clone().add(1, 'hours').format('YYYY-MM-DD HH:mm:ss')})
              else if (ctx.state.range === 1) ctx.setState({ endDate: baseDate.clone().add(3, 'hours').format('YYYY-MM-DD HH:mm:ss')})
              else if (ctx.state.range === 2) ctx.setState({ endDate: baseDate.clone().add(1, 'days').format('YYYY-MM-DD HH:mm:ss')})
              else if (ctx.state.range === 3) ctx.setState({ endDate: null})
            }
          },
          to: {
            col: 4,
            name: "endDate",
            value: "",
            type: "datetime",
            label: `${M}endDateTime`,
            rules: "required",
            opts: {
              timeIntervals: 15,
             },
            renderIf: ctx => ctx.state.endDate || (ctx.state.range === 3 && ctx.state.startDate)
          }
        },
        {
          col: 12,
          name: "desc",
          value: "",
          type: "textarea",
          label: "main.desc",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "img",
          value: "",
          type: "dropzone",
          label: "main.coverImage",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "/admActivity/file",
            accept: '.jpeg,.jpg,.png',
            output: true
          }
        },
        {
          col: 6,
          name: "locationTxt",
          value: "",
          type: "text",
          label: "main.location",
          rules: "max:50",
          opts: {
            style: 'float-label',
          }
        },
        {
          name: "hasDate",
          value: true,
          type: "hidden",
        },        
        {
          col: 12,
          name: "published",
          value: true,
          type: "switch",
          label: `${M}published`,
        },
        {
          type: "daterange",
          isFormCrud: true,
          range: {
            col: 4,
            name: "range2",
            label: "",
            renderIf: (ctx) => ctx.state.published
          },
          from: {
            col: 4,
            name: "publishFrom",
            value: "",
            type: "datetime",
            label: `${M}showFrom`
          },
          to: {
            col: 4,
            name: "publishTo",
            value: "",
            type: "datetime",
            label: `${M}showUntil`
          }
        },
        {
          col: 6,
          name: "superSections",
          value: "",
          type: "select",
          label: `${M}visibleForSections`,
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true",
            isMulti: true,
            setOutput: v => v
          },
          renderIf: (ctx) => ctx.state.published
        },
        {
          col: 6,
          name: "sections",
          value: "",
          type: "select",
          label: `${M}visibleForSubsections`,
          parent: 'superSections',
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + ((context.state.form.superSections && context.state.form.superSections.length > 0) ? context.state.form.superSections[0].value : null) },
            isMulti: true,
            setOutput: v => v
          },
          renderIf: (ctx) => { return (ctx.state.superSections && ctx.state.superSections.length === 1) || (ctx.state.sections && ctx.state.sections.length >= 1)}
        },
        {
          col: 12,
          name: "tab1",
          value: false,
          type: "collapsible",
          placeholder: 'main.seeMoreOptions',
          childs: [
            {
              col: 12,
              name: "nameEN",
              value: "",
              type: "text",
              label: L => `${L["main.title"]} - ${L["main.secondaryLanguage"]}`,
              aiAssist: {
                action: 'translate',
                requiredFields: ["name", "desc"],
                postUrl: "admPublication/AiAssist"
              },
              opts: {
                style: 'float-label'
              }
            },
            {
              col: 12,
              name: "descEN",
              value: "",
              type: "textarea",
              label: L => `${L["main.desc"]} - ${L["main.secondaryLanguage"]}`,
              opts: {
                style: 'float-label'
              }
            },
            {
              col: 6,
              name: "categoryId",
              value: "",
              type: "select",
              label: "main.category",
              opts: {
                style: 'float-label',
                path: "/admCategory/get?type=cal"
              }
            },
            {
              col: 6,
              name: "owner",
              value: "",
              type: "select",
              label: "main.responsible",
              opts: {
                style: 'float-label',
                path: "/admStaff/get?pick=true"
              }
            },
            {
              col: 12,
              name: "label1",
              value: (L) =>  `<h5>${L[`${M}whoCanSeeThisActivity`]}</h5`,
              type: "label"
            },
            {
              col: 6,
              name: "accessPrincipal",
              value: true,
              type: "switch",
              label: `${M}mainUsersParentsGuardians`,
            },
            {
              col: 6,
              name: "accessDependant",
              value: true,
              type: "switch",
              label: `${M}dependentUsersChildrenDependents`,
            },
            {
              col: 12,
              name: "accessMaster",
              value: true,
              type: "switch",
              label: `${M}staffTeachersUsers`,
            },
            {
              col: 9,
              name: "btnDelete",
              value: true,
              type: "button",
              label: "main.delete",
              opts: {
                labelBeforeButton: `${M}deleteEvent`,
                kind: "danger"
              },
              onClick: () => {
                context.toggleDelete(context.state.idItemSelected)
              },
              renderIf: () => context.state.idItemSelected
            }
          ]
        }
      ]
    },

    columns: [],

    customComponent: CustomCalendar
  }
}